module.exports = __webpack_public_path__ + "img/w3_phone_light.731e4f29.png";